import { SocialHero } from "./styles";

export function Social() {
    return (
        <SocialHero>
            <li>
                <a href="https://www.instagram.com/jonas.borges93" target="_blank" rel="noopener noreferrer">
                    <i className="uil uil-instagram"></i>
                </a>
            </li>
            <li>
                <a href="https://www.linkedin.com/in/jonasborges93/" target="_blank" rel="noopener noreferrer">
                    <i className="uil uil-linkedin-alt"></i>
                </a>
            </li>
            <li>
                <a href="https://github.com/jonasborges93" target="_blank" rel="noreferrer">
                    <i className="uil uil-github-alt"></i>
                </a>
            </li>
        </SocialHero>
    )
}